import React from 'react';
import { connect } from "react-redux";
import { setLoading } from '../../redux/actions';
import LzDimmer from '../commons/dimmer';
import { NotificationContainer } from 'react-notifications';

import 'react-notifications/lib/notifications.css';

class PublicLayout extends React.Component {

    render() {
        const { loading, children } = this.props;

        return (
            <div
                className={'lz-full-bg-wrapper lz-full-bg-wrapper-bg1'}
                style={{
                    minWidth: '364px',
                    minHeight: '100vh',
                }}
            >

                <div style={{ minHeight: '100%' }}>

                    <LzDimmer active={loading} />

                    {children}

                </div>

                <NotificationContainer />

            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        loading: state.commons.loading,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setLoading: (value) => dispatch(setLoading(value)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicLayout);
